import React from "react";
import { calculateNewValue } from "@testing-library/user-event/dist/utils";
import ClientSnapshotContent from "./ClientSnapshotContent";
import SmallLoader from "../../Common/smallLoader";
import { Constants } from "../../../CommonMethhods/Constants";
import Form from "react-bootstrap/Form";

function ClientSnapshot(props) {
  const yearly = props.filterTabsId[0];
  const monthly = props.filterTabsId[1];
  const weekly = props.filterTabsId[2];
  const Yesterday = props.filterTabsId[3];
  const Clientloader = props.loaderClient;

  return (
    <>
      <div className="snapshot-detail-block revenue-detail">
        <div className="card-title">
          <h2>
            {props.title}
            {/* <span>{Constants.Amount_In_Lacs}</span> */}
          </h2>

          <div className="card-right card-right-client-snap ">
            {/* <div className="generate-btn-wrapper mt-0">
              <button className="generate-btn excel1 text-green" value="excel">
                <>
                  <span className="icon-excelsvg"></span>
                  {"Excel"}
                </>
              </button>
              <button className="generate-btn pdf1 txt-purple" value="pdf">
                <>
                  <span className="icon-pdfsvg"></span> {"PDF"}
                </>
              </button>
            </div> */}
            <div className="card-tabs mt-0">
              {/* <!-- Filter Tabs --> */}
              {/* <div className="card-tab-list filter-tabs mb-0">
                <ul className="nav nav-tabs" id="clientTab" role="tablist">
                  <li
                    className="nav-item"
                    role="presentation"
                    onClick={() => props.getClientSnapshotDetails("yearly")}
                  >
                    <button
                      className="nav-link"
                      id="yearly-tab"
                      data-toggle="tab"
                      data-target={"#" + yearly}
                      type="button"
                      role="tab"
                      aria-controls="yearly"
                      aria-selected="false"
                      tabIndex="-1"
                    >
                      {Constants.Yearly}
                    </button>
                  </li>
                  <li
                    className="nav-item"
                    role="presentation"
                    onClick={() => props.getClientSnapshotDetails("monthly")}
                  >
                    <button
                      className="nav-link active"
                      data-toggle="tab"
                      data-target={"#" + monthly}
                      type="button"
                      role="tab"
                      aria-controls="monthly"
                      aria-selected="false"
                      tabIndex="-1"
                    >
                      {Constants.Monthly}
                    </button>
                  </li>
                  <li
                    className="nav-item"
                    role="presentation"
                    onClick={() => props.getClientSnapshotDetails("weekly")}
                  >
                    <button
                      className="nav-link"
                      id="weekly-tab"
                      data-toggle="tab"
                      data-target={"#" + weekly}
                      type="button"
                      role="tab"
                      aria-controls="weekly"
                      aria-selected="true"
                    >
                      {Constants.Weekly}
                    </button>
                  </li>
                </ul>
              </div> */}
              {/* <!-- dropdown --> */}
              <div className="dropdown-filter">
                <Form.Select
                  size="lg"
                  aria-label="Default select example"
                  onChange={(e) => props.handleClientSnapFilter(e.target.value)}
                >
                  <option value="Yearly">{Constants.Yearly}</option>
                  <option value="Monthly">{Constants.Monthly}</option>
                  <option value="Weekly">{Constants.Weekly}</option>
                  <option value="Yesterday">{Constants.Yesterday}</option>
                </Form.Select>
              </div>
            </div>
          </div>
        </div>

        {/* <!-- Filter Tab Content --> */}

        <div className="tab-content" id="clientSnapshotTabConntent">
          {/* yearly */}

          <ClientSnapshotContent
            loader={Clientloader}
            id={yearly}
            filterBy="yearly"
            AcqClients={props.clientTableData.newacquiredclients}
            inActiveClients={props.clientTableData.inactiveclients}
            topBrokClients={props.clientTableData.topbrokingclients}
            topClientsMTF={props.clientTableData.topclientsmtf}
          />

          {/* monthly */}

          <ClientSnapshotContent
            loader={Clientloader}
            id={monthly}
            filterBy="monthly"
            AcqClients={props.clientTableData.newacquiredclients}
            inActiveClients={props.clientTableData.inactiveclients}
            topBrokClients={props.clientTableData.topbrokingclients}
            topClientsMTF={props.clientTableData.topclientsmtf}
          />

          {/* weekly */}

          <ClientSnapshotContent
            loader={Clientloader}
            id={weekly}
            filterBy="weekly"
            AcqClients={props.clientTableData.newacquiredclients}
            inActiveClients={props.clientTableData.inactiveclients}
            topBrokClients={props.clientTableData.topbrokingclients}
            topClientsMTF={props.clientTableData.topclientsmtf}
          />

          <ClientSnapshotContent
            loader={Clientloader}
            id={Yesterday}
            filterBy="Yesterday"
            AcqClients={props.clientTableData.newacquiredclients}
            inActiveClients={props.clientTableData.inactiveclients}
            topBrokClients={props.clientTableData.topbrokingclients}
            topClientsMTF={props.clientTableData.topclientsmtf}
          />
        </div>
      </div>
    </>
  );
}

export default React.memo(ClientSnapshot);
